export default __webpack_public_path__ + "static/media/hero.2e927f6d.mp4";